<template>
  <NoCustomerState v-if="!selectedCustomerId" :hasCustomers="hasCustomers" />
  <div v-else>
    <div class="tw-flex tw-flex-row tw-justify-end tw-px-4 tw-items-end tw-mb-4">
      <button
        @click="navigateToCreateRecurringOrder"
        class="tw-text-sm tw-font-semibold tw-text-primary-400 tw-underline hover:tw-text-primary-600 tw-transition-colors tw-duration-300"
      >
        {{ t('orders.titles.new_recurring') }}
      </button>
    </div>
    <RecurringOrdersFancyTable :customerId="selectedCustomerId" :isDashboard="false" />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useCustomerStore } from '@/stores/customer.store';
import RecurringOrdersFancyTable from '@/views/RecurringOrders/Table/RecurringOrdersFancyTable.vue';
import NoCustomerState from '@/components/shared/NoCustomerState.vue';
import { useI18n } from 'vue-i18n';
import router from '@/router';
import { useBreadcrumbs } from '@/composables/useBreadcrumbs';

const navigateToCreateRecurringOrder = () => {
  router.push({ name: 'create-recurring-order' });
};

const { t } = useI18n();
const { setBreadcrumbs } = useBreadcrumbs();
const { hasCustomers, selectedCustomerId } = storeToRefs(useCustomerStore());

const { getCustomersOptions } = useCustomerStore();

let customersList: any = ref([]);

onMounted(async () => {
  setBreadcrumbs([
    {
      labelKey: 'sidebar.items.recurring_orders',
    },
  ]);

  customersList.value = await getCustomersOptions();
});
</script>
